import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/voyage-planner/(with-header)/@header/LayoutHeaderSkeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Footer/skeleton.module.scss");
